import TreatmentSelect from './TreatmentSelect';
import TreatmentSelectUI from './TreatmentSelectUI';

export default TreatmentSelect;

export { TreatmentSelectUI };
